import { parseDate, useLocale } from '@mirai/locale';
import { styles, Text, useDevice, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React from 'react';

import * as style from './Summary.module.css';
import { FORMAT_DATE } from '../../Booking.constants';
import { L10N } from '../../Booking.l10n';

const Summary = ({
  cancellation: { caption, name } = {},
  currency,
  dates: { checkIn, checkOut, checkInTime, checkOutTime } = {},
  price: { value } = {},
  priceBreakdown: { taxes = [], fees = [] } = {},
  title,
  ...others
}) => {
  const { isDesktop } = useDevice();
  const { currencyFormat, dateFormat, translate } = useLocale();

  return (
    <View {...others} className={styles(style.summary, others.className)}>
      <Text bold headline={isDesktop}>
        {title}
      </Text>

      <View row wide className={style.dates}>
        <View>
          <Text bold>{translate(L10N.LABEL_CHECK_IN)}</Text>
          <View>
            <Text action>{dateFormat(parseDate(checkIn), FORMAT_DATE)}</Text>
            {checkInTime && (
              <Text light small>
                {translate(L10N.LABEL_CHECKIN_TIME, { value: checkInTime })}
              </Text>
            )}
          </View>
        </View>

        <View>
          <Text bold>{translate(L10N.LABEL_CHECK_OUT)}</Text>
          <View>
            <Text action>{dateFormat(parseDate(checkOut), FORMAT_DATE)}</Text>
            {checkOutTime && (
              <Text light small>
                {translate(L10N.LABEL_CHECKOUT_TIME, { value: checkOutTime })}
              </Text>
            )}
          </View>
        </View>
      </View>
      <View wide className={style.cancellation}>
        <Text bold>{translate(L10N.LABEL_CANCELLATION_POLICY)}</Text>
        <Text action bold className={style.free}>
          {name}
        </Text>
        <Text small>{caption}</Text>
      </View>
      <View wide>
        <Text bold>{translate(L10N.LABEL_TOTAL)}</Text>
        <Text bold headline>
          {currencyFormat({ currency, value })}
        </Text>
        {(taxes.length > 0 || fees.length > 0) && <Text small>{translate(L10N.LABEL_INCLUDES_TAXES)}</Text>}
      </View>
    </View>
  );
};

Summary.displayName = 'Mirai:Core:Booking:Summary';

Summary.propTypes = {
  cancellation: PropTypes.any,
  currency: PropTypes.string,
  dates: PropTypes.any,
  price: PropTypes.any,
  priceBreakdown: PropTypes.any,
  title: PropTypes.string,
};

export { Summary };
